import styled from 'styled-components';

export const StyledUserPanelSummary = styled.div`
    width: 100%;
    height: 100%;
`;
